import { render, staticRenderFns } from "./WhyOurDeliveryFasterBlock.vue?vue&type=template&id=3da189cc&scoped=true&"
import script from "./WhyOurDeliveryFasterBlock.vue?vue&type=script&lang=js&"
export * from "./WhyOurDeliveryFasterBlock.vue?vue&type=script&lang=js&"
import style0 from "./WhyOurDeliveryFasterBlock.vue?vue&type=style&index=0&id=3da189cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da189cc",
  null
  
)

export default component.exports